import * as mdb from 'mdb-ui-kit';
import {
  Notyf
} from 'notyf';
/*
import {
  defineAsyncComponent,
  createApp
} from 'vue'
*/
/*
const Baneris = require('../app/webroot/js/baneris.js');
const AlertBox = require('../app/webroot/js/AlertBox.min.js');
const ConfirmBox2 = require('../app/webroot/js/ConfirmBox2.min.js');
const PictureWindow2 = require('../app/webroot/js/PictureWindow2.js');
const ColorSelectorPrototype = require('../app/webroot/js/ColorSelectorPrototype.js');
*/
window.mdb = mdb;
/*
const app = createApp({});
app.mount('#mapp');

*/


const element = window.document.getElementById('prekeideta');
window.parduotuvemodalinstance = new mdb.Modal(element);


window.notyf = new Notyf({
  types: [{
    type: 'info',
    background: 'blue',
    icon: false
  }],
  duration: 1000,
  position: {
    x: 'right',
    y: 'top',
  },
});
window.tumb = () => import('./components/editor_load.js');
var slots = document.getElementsByClassName('editor');
if (slots && (slots.length > 0)) {
  tumb()
    .then(trumb => {
      $('.editor')
        .trumbowyg({
          tagClasses: {
            h1: 'h1', // Bootstrap example
            blockquote: 'blockquote',
            table: 'table',
          }
        });
    });
}
const myModalEl = document.getElementById('bannermodal')
if ((typeof(myModalEl) !== 'undefined') && (myModalEl !== null)) {
  const modal = new mdb.Modal(myModalEl)
  modal.show()
}
export default {
  mdb,

};
